import { cloneElement, createElement, isValidElement } from "react";
import { useCurrentColor } from "./useCurrentColor";
const useGetThemedIcon = (props) => {
  const color = useCurrentColor(props.color);
  return (el) => {
    if (!el)
      return el;
    if (isValidElement(el)) {
      return cloneElement(el, {
        ...props,
        color,
        // @ts-expect-error
        ...el.props
      });
    }
    return createElement(el, props);
  };
};
export {
  useGetThemedIcon
};
//# sourceMappingURL=useGetThemedIcon.js.map
